import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoCheckSmall16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M3.3999 8.92478L6.1599 11.7176L12.5999 4.27002" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoCheckSmall16;